export default "__VITE_ASSET__DN29XHX2__"